import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ViewHeadlineIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"view_headline"} ref={ref}/>
});

ViewHeadlineIcon.displayName = "ViewHeadlineIcon";
